<div class="tw-mb-4 tw-flex tw-flex-col xl:!tw-flex-row tw-gap-2">
  <div class="tw-flex tw-items-center">
    <mat-checkbox class="tw-mr-1" name="weeklyRecurrenceMonday" [ngModel]="days.monday" (ngModelChange)="update('monday', $event)" />
    <span class="tw-cursor-pointer" (click)="update('monday', !days.monday)">Mon</span>
  </div>
  <div class="tw-flex tw-items-center">
    <mat-checkbox class="tw-mr-1" name="weeklyRecurrenceTuesday" [ngModel]="days.tuesday" (ngModelChange)="update('tuesday', $event)" />
    <span class="tw-cursor-pointer" (click)="update('tuesday', !days.tuesday)">Tue</span>
  </div>
  <div class="tw-flex tw-items-center">
    <mat-checkbox class="tw-mr-1" name="weeklyRecurrenceWednesday" [ngModel]="days.wednesday" (ngModelChange)="update('wednesday', $event)" />
    <span class="tw-cursor-pointer" (click)="update('wednesday', !days.wednesday)">Wed</span>
  </div>
  <div class="tw-flex tw-items-center">
    <mat-checkbox class="tw-mr-1" name="weeklyRecurrenceThursday" [ngModel]="days.thursday" (ngModelChange)="update('thursday', $event)" />
    <span class="tw-cursor-pointer" (click)="update('thursday', !days.thursday)">Thu</span>
  </div>
  <div class="tw-flex tw-items-center">
    <mat-checkbox class="tw-mr-1" name="weeklyRecurrenceFriday" [ngModel]="days.friday" (ngModelChange)="update('friday', $event)" />
    <span class="tw-cursor-pointer" (click)="update('friday', !days.friday)">Fri</span>
  </div>
  <div class="tw-flex tw-items-center">
    <mat-checkbox class="tw-mr-1" name="weeklyRecurrenceSaturday" [ngModel]="days.saturday" (ngModelChange)="update('saturday', $event)" />
    <span class="tw-cursor-pointer" (click)="update('saturday', !days.saturday)">Sat</span>
  </div>
  <div class="tw-flex tw-items-center">
    <mat-checkbox class="tw-mr-1" name="weeklyRecurrenceSunday" [ngModel]="days.sunday" (ngModelChange)="update('sunday', $event)" />
    <span class="tw-cursor-pointer" (click)="update('sunday', !days.sunday)">Sun</span>
  </div>
</div>